import { useInlineStatusQuery } from "@octopusdeploy/octopus-react-client";
import { useEffect } from "react";
import { client } from "~/clientInstance";
import { AddLicenseBanner } from "./AddLicenseBanner";
import { LicenseCountdownBanner } from "./LicenseCountdownBanner";
export function NavigationBanner() {
    const { result: licenseStatus, refetch } = useInlineStatusQuery(async (repository) => await repository.Licenses.getCurrentStatus(), [], "Get license current status");
    useEffect(() => {
        return client.subscribe((event) => {
            if (event.type === "LicenseModified") {
                refetch();
            }
        });
    }, [refetch]);
    const isInitialisationLicense = !!licenseStatus?.IsInitialisationLicense;
    const showLicenseCountdownBanner = !!licenseStatus && licenseStatus.DaysToEffectiveExpiryDate !== undefined && licenseStatus.IsTrial;
    if (isInitialisationLicense) {
        return <AddLicenseBanner licenseStatus={licenseStatus}/>;
    }
    else if (showLicenseCountdownBanner) {
        return <LicenseCountdownBanner licenseStatus={licenseStatus}/>;
    }
    return null;
}
